import React from 'react';

import * as Styled from './StyledNavigation';

export const Navigation = ({ children }) => <Styled.Navigation>{children}</Styled.Navigation>;
